export default "__VITE_ASSET__d81c099d__"